import { Suspense } from 'react';
import { createFileRoute } from '@tanstack/react-router';
import { ErrorBoundary } from '@/components/common/ErrorBoundary';
import { PageLoader } from '@/components/common/PageLoader';
import { PromoItemTypePage } from '@/features/promotion/pages/PromoItemTypePage';
import { promoCatalogueSearchSchema } from '@/features/promotion/types/promotion.types';

export const Route = createFileRoute('/_auth/promotion/item-types')({
  validateSearch: promoCatalogueSearchSchema,
  component: () => (
    <ErrorBoundary moduleName="Promotional Item Type">
      <Suspense fallback={<PageLoader />}>
        <PromoItemTypePage />
      </Suspense>
    </ErrorBoundary>
  ),
});
